import { render, staticRenderFns } from "./SupplementItem.vue?vue&type=template&id=6b87ab10&scoped=true&"
import script from "./SupplementItem.vue?vue&type=script&lang=js&"
export * from "./SupplementItem.vue?vue&type=script&lang=js&"
import style0 from "./SupplementItem.vue?vue&type=style&index=0&id=6b87ab10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b87ab10",
  null
  
)

export default component.exports